// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General */
.preloader {
  position: fixed;
  z-index: 999999;
  background: #edf1f5;
  width: 100%;
  height: 100%;
}

.preloader-content {
  border: 0 solid transparent;
  border-radius: 50%;
  width: 150px;
  height: 150px;
  position: absolute;
  top: calc(50vh - 75px);
  left: calc(50vw - 75px);
}

.preloader-content:before, .preloader-content:after {
  content: "";
  border: 1em solid var(--primary-color);
  border-radius: 50%;
  width: inherit;
  height: inherit;
  position: absolute;
  top: 0;
  left: 0;
  animation: loader 2s linear infinite;
  opacity: 0;
}

.preloader-content:before {
  animation-delay: 0.5s;
}

@keyframes loader {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
* {
  box-sizing: border-box;
}

html {
  height: 100%;
  font-size: 10px;
}

body {
  font-family: var(--font-family);
  color: var(--text-color);
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  min-height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a, button {
  text-decoration: none;
  color: var(--primary-color);
}

.layout-theme-light {
  background-color: #ffffff;
}

.layout-topbar {
  position: fixed;
  height: 5rem;
  z-index: 997;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0 2rem;
  background-color: var(--surface-card);
  transition: left 0.2s;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}
.layout-topbar .layout-topbar-logo {
  display: flex;
  align-items: center;
  color: var(--surface-900);
  font-size: 1.5rem;
  font-weight: 500;
  width: 300px;
  border-radius: 12px;
}
.layout-topbar .layout-topbar-logo img {
  height: 2.5rem;
  margin-right: 0.5rem;
}
.layout-topbar .layout-topbar-logo:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: var(--text-color-secondary);
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
  transition: background-color 0.2s;
}
.layout-topbar .layout-topbar-button:hover {
  color: var(--text-color);
  background-color: var(--surface-hover);
}
.layout-topbar .layout-topbar-button:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: var(--focus-ring);
}
.layout-topbar .layout-topbar-button i {
  font-size: 1.5rem;
}
.layout-topbar .layout-topbar-button span {
  font-size: 1rem;
  display: none;
}
.layout-topbar .layout-menu-button {
  margin-left: 2rem;
}
.layout-topbar .layout-topbar-menu-button {
  display: none;
}
.layout-topbar .layout-topbar-menu-button i {
  font-size: 1.25rem;
}
.layout-topbar .layout-topbar-menu {
  margin: 0 0 0 auto;
  padding: 0;
  list-style: none;
  display: flex;
}
.layout-topbar .layout-topbar-menu .layout-topbar-button {
  margin-left: 1rem;
}

@media (max-width: 991px) {
  .layout-topbar {
    justify-content: space-between;
  }
  .layout-topbar .layout-topbar-logo {
    width: auto;
    order: 2;
  }
  .layout-topbar .layout-menu-button {
    margin-left: 0;
    order: 1;
  }
  .layout-topbar .layout-topbar-menu-button {
    display: inline-flex;
    margin-left: 0;
    order: 3;
  }
  .layout-topbar .layout-topbar-menu {
    margin-left: 0;
    position: absolute;
    flex-direction: column;
    background-color: var(--surface-overlay);
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
    border-radius: 12px;
    padding: 1rem;
    right: 2rem;
    top: 5rem;
    min-width: 15rem;
    display: none;
    animation: scalein 0.15s linear;
  }
  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {
    display: block;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button {
    margin-left: 0;
    display: flex;
    width: 100%;
    height: auto;
    justify-content: flex-start;
    border-radius: 12px;
    padding: 1rem;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button i {
    font-size: 1rem;
    margin-right: 0.5rem;
  }
  .layout-topbar .layout-topbar-menu .layout-topbar-button span {
    font-weight: medium;
    display: block;
  }
}
.layout-sidebar {
  position: fixed;
  width: 300px;
  height: calc(100vh - 9rem);
  z-index: 999;
  overflow-y: auto;
  -webkit-user-select: none;
          user-select: none;
  top: 7rem;
  left: 2rem;
  transition: transform 0.2s, left 0.2s;
  background-color: var(--surface-overlay);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
}

.layout-menu {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.layout-menu li.layout-menuitem-category {
  margin-top: 0.75rem;
}
.layout-menu li.layout-menuitem-category:first-child {
  margin-top: 0;
}
.layout-menu li .layout-menuitem-root-text {
  text-transform: uppercase;
  color: var(--surface-900);
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
.layout-menu li a {
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  color: var(--text-color);
  transition: color 0.2s;
  border-radius: 12px;
  padding: 0.75rem 1rem;
  transition: background-color 0.15s;
}
.layout-menu li a span {
  margin-left: 0.5rem;
}
.layout-menu li a .menuitem-toggle-icon {
  margin-left: auto;
}
.layout-menu li a:focus {
  outline: 0 none;
  outline-offset: 0;
  transition: box-shadow 0.2s;
  box-shadow: inset var(--focus-ring);
}
.layout-menu li a:hover {
  background-color: var(--surface-hover);
}
.layout-menu li a.router-link-exact-active {
  font-weight: 700;
  color: var(--primary-color);
}
.layout-menu li a .p-badge {
  margin-left: auto;
}
.layout-menu li.active-menuitem > a .menuitem-toggle-icon:before {
  content: "\\e933";
}
.layout-menu li ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.layout-menu li ul.layout-submenu-wrapper-enter {
  max-height: 0;
}
.layout-menu li ul.layout-submenu-wrapper-enter-active {
  overflow: hidden;
  max-height: 1000px;
  transition: max-height 1s ease-in-out;
}
.layout-menu li ul.layout-submenu-wrapper-enter-done {
  transform: none;
}
.layout-menu li ul.layout-submenu-wrapper-exit {
  max-height: 1000px;
}
.layout-menu li ul.layout-submenu-wrapper-exit-active {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);
}
.layout-menu li ul ul {
  padding-left: 1rem;
}

.layout-config {
  position: fixed;
  top: 0;
  padding: 0;
  right: 0;
  width: 20rem;
  z-index: 999;
  height: 100vh;
  transform: translateX(100%);
  transition: transform 0.2s;
  backface-visibility: hidden;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08) !important;
  color: var(--text-color);
  background-color: var(--surface-overlay);
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
}
.layout-config.layout-config-active {
  transform: translateX(0);
}
.layout-config .layout-config-button {
  display: block;
  position: absolute;
  width: 52px;
  height: 52px;
  line-height: 52px;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
  text-align: center;
  top: 230px;
  left: -52px;
  z-index: -1;
  overflow: hidden;
  cursor: pointer;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  transition: background-color 0.2s;
}
.layout-config .layout-config-button i {
  font-size: 32px;
  line-height: inherit;
  cursor: pointer;
  transform: rotate(0deg);
  transition: color 0.2s, transform 1s;
}
.layout-config .layout-config-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  z-index: 1;
}
.layout-config .layout-config-content {
  position: relative;
  overflow: auto;
  height: 100vh;
  padding: 2rem;
}
.layout-config .config-scale {
  display: flex;
  align-items: center;
  margin: 1rem 0 2rem 0;
}
.layout-config .config-scale .p-button {
  margin-right: 0.5rem;
}
.layout-config .config-scale i {
  margin-right: 0.5rem;
  font-size: 0.75rem;
  color: var(--text-color-secondary);
}
.layout-config .config-scale i.scale-active {
  font-size: 1.25rem;
  color: var(--primary-color);
}
.layout-config .free-themes img {
  width: 2rem;
  border-radius: 4px;
  transition: transform 0.2s;
  display: block;
}
.layout-config .free-themes img:hover {
  transform: scale(1.1);
}
.layout-config .free-themes span {
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.layout-main-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  padding: 2rem 2rem 2rem 4rem;
  transition: margin-left 0.2s;
}

.layout-main {
  flex: 1 1 auto;
}

.layout-footer {
  transition: margin-left 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  border-top: 1px solid var(--surface-border);
}

@media (min-width: 992px) {
  .layout-wrapper.layout-overlay .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper.layout-overlay .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
    top: 0;
    height: 100vh;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-wrapper.layout-static .layout-main-container {
    margin-left: 300px;
  }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
  }
  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper .layout-mask {
    display: none;
  }
}
@media (max-width: 991px) {
  .layout-wrapper .layout-main-container {
    margin-left: 0;
    padding-left: 2rem;
  }
  .layout-wrapper .layout-sidebar {
    transform: translateX(-100%);
    left: 0;
    top: 0;
    height: 100vh;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .layout-wrapper .layout-mask {
    z-index: 998;
    background-color: var(--mask-bg);
  }
  .layout-wrapper .layout-mask.layout-mask-enter-from, .layout-wrapper .layout-mask.layout-mask-leave-to {
    background-color: transparent;
  }
  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {
    transform: translateX(0);
  }
  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {
    display: block;
  }
  .body-overflow-hidden {
    overflow: hidden;
  }
}
.card {
  background-color: var(--surface-card);
  padding: 1.5rem;
  margin-bottom: 1rem;
  border-radius: 12px;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08) !important;
}
.card.card-w-title {
  padding-bottom: 2rem;
}

h1, h2, h3, h4, h5, h6 {
  margin: 1.5rem 0 1rem 0;
  font-family: inherit;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
}
h1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {
  margin-top: 0;
}

h1 {
  font-size: 2.5rem;
}

h2 {
  font-size: 2rem;
}

h3 {
  font-size: 1.75rem;
}

h4 {
  font-size: 1.5rem;
}

h5 {
  font-size: 1.25rem;
}

h6 {
  font-size: 1rem;
}

mark {
  background: #FFF8E1;
  padding: 0.25rem 0.4rem;
  border-radius: 12px;
  font-family: monospace;
}

blockquote {
  margin: 1rem 0;
  padding: 0 2rem;
  border-left: 4px solid #90A4AE;
}

hr {
  border-top: solid var(--surface-border);
  border-width: 1px 0 0 0;
  margin: 1rem 0;
}

p {
  margin: 0 0 1rem 0;
  line-height: 1.5;
}
p:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/layout/_variables.scss","webpack://./src/assets/layout/sass/_splash.scss","webpack://./src/assets/layout/layout.scss","webpack://./src/assets/layout/sass/_main.scss","webpack://./src/assets/layout/sass/_topbar.scss","webpack://./src/assets/layout/sass/_mixins.scss","webpack://./src/assets/layout/sass/_menu.scss","webpack://./src/assets/layout/sass/_config.scss","webpack://./src/assets/layout/sass/_content.scss","webpack://./src/assets/layout/sass/_footer.scss","webpack://./src/assets/layout/sass/_responsive.scss","webpack://./src/assets/layout/sass/_utils.scss","webpack://./src/assets/layout/sass/_typography.scss"],"names":[],"mappings":"AAAA,YAAA;ACAA;EACI,eAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;ACEJ;;ADAA;EACI,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;ACGJ;;ADAA;EACI,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,UAAA;ACGJ;;ADAA;EACI,qBAAA;ACGJ;;ADAA;EACI;IACI,mBAAA;IACA,UAAA;ECGN;EDDE;IACI,UAAA;ECGN;EDDE;IACI,mBAAA;IACA,UAAA;ECGN;AACF;AChDA;EACI,sBAAA;ADkDJ;;AC/CA;EACI,YAAA;EACA,eHLM;AEuDV;;AC/CA;EACI,+BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mCAAA;EACA,kCAAA;ADkDJ;;AC/CA;EACI,qBAAA;EACA,2BAAA;ADkDJ;;AC/CA;EACI,yBAAA;ADkDJ;;AE5EA;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,6GAAA;AF+EJ;AE7EI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AF+ER;AE7EQ;EACI,cAAA;EACA,oBAAA;AF+EZ;AE5EQ;EC3BJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AH0GJ;AE7EI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;AF+ER;AE7EQ;EACI,wBAAA;EACA,sCAAA;AF+EZ;AE5EQ;ECjDJ,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;AHgIJ;AE9EQ;EACI,iBAAA;AFgFZ;AE7EQ;EACI,eAAA;EACA,aAAA;AF+EZ;AE3EI;EACI,iBAAA;AF6ER;AE1EI;EACI,aAAA;AF4ER;AE1EQ;EACI,kBAAA;AF4EZ;AExEI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;AF0ER;AExEQ;EACI,iBAAA;AF0EZ;;AErEA;EACI;IACI,8BAAA;EFwEN;EEtEM;IACI,WAAA;IACA,QAAA;EFwEV;EErEM;IACI,cAAA;IACA,QAAA;EFuEV;EEpEM;IACI,oBAAA;IACA,cAAA;IACA,QAAA;EFsEV;EEnEM;IACI,cAAA;IACA,kBAAA;IACA,sBAAA;IACA,wCAAA;IACA,6GAAA;IACA,mBAAA;IACA,aAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;IACA,aAAA;IAEA,+BAAA;EFqEV;EEnEU;IACI,cAAA;EFqEd;EElEU;IACI,cAAA;IACA,aAAA;IACA,WAAA;IACA,YAAA;IACA,2BAAA;IACA,mBAAA;IACA,aAAA;EFoEd;EElEc;IACI,eAAA;IACA,oBAAA;EFoElB;EEjEc;IACI,mBAAA;IACA,cAAA;EFmElB;AACF;AInNA;EACI,eAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,6GAAA;AJqNJ;;AIlNA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AJqNJ;AIlNQ;EACI,mBAAA;AJoNZ;AIlNY;EACI,aAAA;AJoNhB;AIhNQ;EACI,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AJkNZ;AI/MQ;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBN3CE;EM4CF,qBAAA;EACA,kCAAA;AJiNZ;AI/MY;EACI,mBAAA;AJiNhB;AI9MY;EACI,iBAAA;AJgNhB;AI7MY;EDjDR,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,mCAAA;AHiQJ;AI/MY;EACI,sCAAA;AJiNhB;AI9MY;EACI,gBAAA;EACA,2BAAA;AJgNhB;AI7MY;EACI,iBAAA;AJ+MhB;AIxMoB;EACI,gBAAA;AJ0MxB;AIpMQ;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AJsMZ;AIpMY;EACI,aAAA;AJsMhB;AInMY;EACI,gBAAA;EACA,kBAAA;EACA,qCAAA;AJqMhB;AIlMY;EACI,eAAA;AJoMhB;AIjMY;EACI,kBAAA;AJmMhB;AIhMY;EACI,gBAAA;EACA,aAAA;EACA,2DAAA;AJkMhB;AI/LY;EACI,kBAAA;AJiMhB;;AKpTA;EACI,eAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,wHAAA;EACA,wBAAA;EACA,wCAAA;EACA,4BAAA;EACA,+BAAA;ALuTJ;AKrTI;EACI,wBAAA;ALuTR;AKpTI;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sCAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,4BPjCM;EOkCN,+BPlCM;EOmCN,6BAAA;EACA,0BAAA;EACA,iCAAA;ALsTR;AKpTQ;EACI,eAAA;EACA,oBAAA;EACA,eAAA;EACA,uBAAA;EACA,oCAAA;ALsTZ;AKlTI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;ALoTR;AKjTI;EACI,kBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;ALmTR;AKhTI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;ALkTR;AKhTQ;EACI,oBAAA;ALkTZ;AK/SQ;EACI,oBAAA;EACA,kBAAA;EACA,kCAAA;ALiTZ;AK/SY;EACI,kBAAA;EACA,2BAAA;ALiThB;AK3SQ;EACI,WAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AL6SZ;AK3SY;EACI,qBAAA;AL6ShB;AKzSQ;EACI,kBAAA;EACA,mBAAA;AL2SZ;;AM9YA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,4BAAA;EACA,4BAAA;ANiZJ;;AM9YA;EACI,cAAA;ANiZJ;;AO3ZA;EACI,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2CAAA;AP8ZJ;;AQpaA;EAGY;IACI,cAAA;IACA,kBAAA;ERqad;EQlaU;IACI,4BAAA;IACA,OAAA;IACA,MAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;ERoad;EQhac;IACI,wBAAA;ERkalB;EQ5ZU;IACI,kBAAA;ER8Zd;EQ1Zc;IACI,4BAAA;IACA,OAAA;ER4ZlB;EQzZc;IACI,cAAA;IACA,kBAAA;ER2ZlB;EQtZM;IACI,aAAA;ERwZV;AACF;AQpZA;EAEQ;IACI,cAAA;IACA,kBAAA;ERqZV;EQlZM;IACI,4BAAA;IACA,OAAA;IACA,MAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;ERoZV;EQjZM;IACI,YAAA;IACA,gCAAA;ERmZV;EQjZU;IAEI,6BAAA;ERkZd;EQ7YU;IACI,wBAAA;ER+Yd;EQ5YU;IACI,cAAA;ER8Yd;EQzYE;IACI,gBAAA;ER2YN;AACF;ASleA;EACI,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,mBXFU;EWGV,wHAAA;AToeJ;ASleI;EACI,oBAAA;AToeR;;AU5eA;EACI,uBAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AV+eJ;AU7eI;EACI,aAAA;AV+eR;;AU3eA;EACI,iBAAA;AV8eJ;;AU3eA;EACI,eAAA;AV8eJ;;AU3eA;EACI,kBAAA;AV8eJ;;AU3eA;EACI,iBAAA;AV8eJ;;AU3eA;EACI,kBAAA;AV8eJ;;AU3eA;EACI,eAAA;AV8eJ;;AU3eA;EACI,mBAAA;EACA,uBAAA;EACA,mBZrCU;EYsCV,sBAAA;AV8eJ;;AU3eA;EACI,cAAA;EACA,eAAA;EACA,8BAAA;AV8eJ;;AU3eA;EACI,uCAAA;EACA,uBAAA;EACA,cAAA;AV8eJ;;AU3eA;EACI,kBAAA;EACA,gBAAA;AV8eJ;AU5eI;EACI,gBAAA;AV8eR","sourcesContent":["/* General */\n$fontSize:10px;\n$borderRadius:12px;\n$transitionDuration:.2s;\n",".preloader {\n    position: fixed;\n    z-index: 999999;\n    background: #edf1f5;\n    width: 100%;\n    height: 100%;\n}\n.preloader-content {\n    border: 0 solid transparent;\n    border-radius: 50%;\n    width: 150px;\n    height: 150px;\n    position: absolute;\n    top: calc(50vh - 75px);\n    left: calc(50vw - 75px);\n}\n\n.preloader-content:before, .preloader-content:after{\n    content: '';\n    border: 1em solid var(--primary-color);\n    border-radius: 50%;\n    width: inherit;\n    height: inherit;\n    position: absolute;\n    top: 0;\n    left: 0;\n    animation: loader 2s linear infinite;\n    opacity: 0;\n}\n\n.preloader-content:before{\n    animation-delay: 0.5s;\n}\n\n@keyframes loader{\n    0%{\n        transform: scale(0);\n        opacity: 0;\n    }\n    50%{\n        opacity: 1;\n    }\n    100%{\n        transform: scale(1);\n        opacity: 0;\n    }\n}\n","/* General */\n.preloader {\n  position: fixed;\n  z-index: 999999;\n  background: #edf1f5;\n  width: 100%;\n  height: 100%;\n}\n\n.preloader-content {\n  border: 0 solid transparent;\n  border-radius: 50%;\n  width: 150px;\n  height: 150px;\n  position: absolute;\n  top: calc(50vh - 75px);\n  left: calc(50vw - 75px);\n}\n\n.preloader-content:before, .preloader-content:after {\n  content: \"\";\n  border: 1em solid var(--primary-color);\n  border-radius: 50%;\n  width: inherit;\n  height: inherit;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: loader 2s linear infinite;\n  opacity: 0;\n}\n\n.preloader-content:before {\n  animation-delay: 0.5s;\n}\n\n@keyframes loader {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 0;\n  }\n}\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  font-size: 10px;\n}\n\nbody {\n  font-family: var(--font-family);\n  color: var(--text-color);\n  background-color: #ffffff;\n  margin: 0;\n  padding: 0;\n  min-height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na, button {\n  text-decoration: none;\n  color: var(--primary-color);\n}\n\n.layout-theme-light {\n  background-color: #ffffff;\n}\n\n.layout-topbar {\n  position: fixed;\n  height: 5rem;\n  z-index: 997;\n  left: 0;\n  top: 0;\n  width: 100%;\n  padding: 0 2rem;\n  background-color: var(--surface-card);\n  transition: left 0.2s;\n  display: flex;\n  align-items: center;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n.layout-topbar .layout-topbar-logo {\n  display: flex;\n  align-items: center;\n  color: var(--surface-900);\n  font-size: 1.5rem;\n  font-weight: 500;\n  width: 300px;\n  border-radius: 12px;\n}\n.layout-topbar .layout-topbar-logo img {\n  height: 2.5rem;\n  margin-right: 0.5rem;\n}\n.layout-topbar .layout-topbar-logo:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  color: var(--text-color-secondary);\n  border-radius: 50%;\n  width: 3rem;\n  height: 3rem;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n.layout-topbar .layout-topbar-button:hover {\n  color: var(--text-color);\n  background-color: var(--surface-hover);\n}\n.layout-topbar .layout-topbar-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: var(--focus-ring);\n}\n.layout-topbar .layout-topbar-button i {\n  font-size: 1.5rem;\n}\n.layout-topbar .layout-topbar-button span {\n  font-size: 1rem;\n  display: none;\n}\n.layout-topbar .layout-menu-button {\n  margin-left: 2rem;\n}\n.layout-topbar .layout-topbar-menu-button {\n  display: none;\n}\n.layout-topbar .layout-topbar-menu-button i {\n  font-size: 1.25rem;\n}\n.layout-topbar .layout-topbar-menu {\n  margin: 0 0 0 auto;\n  padding: 0;\n  list-style: none;\n  display: flex;\n}\n.layout-topbar .layout-topbar-menu .layout-topbar-button {\n  margin-left: 1rem;\n}\n\n@media (max-width: 991px) {\n  .layout-topbar {\n    justify-content: space-between;\n  }\n  .layout-topbar .layout-topbar-logo {\n    width: auto;\n    order: 2;\n  }\n  .layout-topbar .layout-menu-button {\n    margin-left: 0;\n    order: 1;\n  }\n  .layout-topbar .layout-topbar-menu-button {\n    display: inline-flex;\n    margin-left: 0;\n    order: 3;\n  }\n  .layout-topbar .layout-topbar-menu {\n    margin-left: 0;\n    position: absolute;\n    flex-direction: column;\n    background-color: var(--surface-overlay);\n    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n    border-radius: 12px;\n    padding: 1rem;\n    right: 2rem;\n    top: 5rem;\n    min-width: 15rem;\n    display: none;\n    -webkit-animation: scalein 0.15s linear;\n    animation: scalein 0.15s linear;\n  }\n  .layout-topbar .layout-topbar-menu.layout-topbar-menu-mobile-active {\n    display: block;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button {\n    margin-left: 0;\n    display: flex;\n    width: 100%;\n    height: auto;\n    justify-content: flex-start;\n    border-radius: 12px;\n    padding: 1rem;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button i {\n    font-size: 1rem;\n    margin-right: 0.5rem;\n  }\n  .layout-topbar .layout-topbar-menu .layout-topbar-button span {\n    font-weight: medium;\n    display: block;\n  }\n}\n.layout-sidebar {\n  position: fixed;\n  width: 300px;\n  height: calc(100vh - 9rem);\n  z-index: 999;\n  overflow-y: auto;\n  user-select: none;\n  top: 7rem;\n  left: 2rem;\n  transition: transform 0.2s, left 0.2s;\n  background-color: var(--surface-overlay);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);\n}\n\n.layout-menu {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.layout-menu li.layout-menuitem-category {\n  margin-top: 0.75rem;\n}\n.layout-menu li.layout-menuitem-category:first-child {\n  margin-top: 0;\n}\n.layout-menu li .layout-menuitem-root-text {\n  text-transform: uppercase;\n  color: var(--surface-900);\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  font-size: 0.875rem;\n}\n.layout-menu li a {\n  cursor: pointer;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  color: var(--text-color);\n  transition: color 0.2s;\n  border-radius: 12px;\n  padding: 0.75rem 1rem;\n  transition: background-color 0.15s;\n}\n.layout-menu li a span {\n  margin-left: 0.5rem;\n}\n.layout-menu li a .menuitem-toggle-icon {\n  margin-left: auto;\n}\n.layout-menu li a:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  transition: box-shadow 0.2s;\n  box-shadow: inset var(--focus-ring);\n}\n.layout-menu li a:hover {\n  background-color: var(--surface-hover);\n}\n.layout-menu li a.router-link-exact-active {\n  font-weight: 700;\n  color: var(--primary-color);\n}\n.layout-menu li a .p-badge {\n  margin-left: auto;\n}\n.layout-menu li.active-menuitem > a .menuitem-toggle-icon:before {\n  content: \"\\e933\";\n}\n.layout-menu li ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter {\n  max-height: 0;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter-active {\n  overflow: hidden;\n  max-height: 1000px;\n  transition: max-height 1s ease-in-out;\n}\n.layout-menu li ul.layout-submenu-wrapper-enter-done {\n  transform: none;\n}\n.layout-menu li ul.layout-submenu-wrapper-exit {\n  max-height: 1000px;\n}\n.layout-menu li ul.layout-submenu-wrapper-exit-active {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);\n}\n.layout-menu li ul ul {\n  padding-left: 1rem;\n}\n\n.layout-config {\n  position: fixed;\n  top: 0;\n  padding: 0;\n  right: 0;\n  width: 20rem;\n  z-index: 999;\n  height: 100vh;\n  transform: translateX(100%);\n  transition: transform 0.2s;\n  backface-visibility: hidden;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08) !important;\n  color: var(--text-color);\n  background-color: var(--surface-overlay);\n  border-top-left-radius: 12px;\n  border-bottom-left-radius: 12px;\n}\n.layout-config.layout-config-active {\n  transform: translateX(0);\n}\n.layout-config .layout-config-button {\n  display: block;\n  position: absolute;\n  width: 52px;\n  height: 52px;\n  line-height: 52px;\n  background-color: var(--primary-color);\n  color: var(--primary-color-text);\n  text-align: center;\n  top: 230px;\n  left: -52px;\n  z-index: -1;\n  overflow: hidden;\n  cursor: pointer;\n  border-top-left-radius: 12px;\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  transition: background-color 0.2s;\n}\n.layout-config .layout-config-button i {\n  font-size: 32px;\n  line-height: inherit;\n  cursor: pointer;\n  transform: rotate(0deg);\n  transition: color 0.2s, transform 1s;\n}\n.layout-config .layout-config-close {\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  z-index: 1;\n}\n.layout-config .layout-config-content {\n  position: relative;\n  overflow: auto;\n  height: 100vh;\n  padding: 2rem;\n}\n.layout-config .config-scale {\n  display: flex;\n  align-items: center;\n  margin: 1rem 0 2rem 0;\n}\n.layout-config .config-scale .p-button {\n  margin-right: 0.5rem;\n}\n.layout-config .config-scale i {\n  margin-right: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--text-color-secondary);\n}\n.layout-config .config-scale i.scale-active {\n  font-size: 1.25rem;\n  color: var(--primary-color);\n}\n.layout-config .free-themes img {\n  width: 2rem;\n  border-radius: 4px;\n  transition: transform 0.2s;\n  display: block;\n}\n.layout-config .free-themes img:hover {\n  transform: scale(1.1);\n}\n.layout-config .free-themes span {\n  font-size: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.layout-main-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  justify-content: space-between;\n  padding: 2rem 2rem 2rem 4rem;\n  transition: margin-left 0.2s;\n}\n\n.layout-main {\n  flex: 1 1 auto;\n}\n\n.layout-footer {\n  transition: margin-left 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 1rem;\n  border-top: 1px solid var(--surface-border);\n}\n\n@media (min-width: 992px) {\n  .layout-wrapper.layout-overlay .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper.layout-overlay .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n    top: 0;\n    height: 100vh;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .layout-wrapper.layout-overlay.layout-overlay-sidebar-active .layout-sidebar {\n    transform: translateX(0);\n  }\n  .layout-wrapper.layout-static .layout-main-container {\n    margin-left: 300px;\n  }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n  }\n  .layout-wrapper.layout-static.layout-static-sidebar-inactive .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper .layout-mask {\n    display: none;\n  }\n}\n@media (max-width: 991px) {\n  .layout-wrapper .layout-main-container {\n    margin-left: 0;\n    padding-left: 2rem;\n  }\n  .layout-wrapper .layout-sidebar {\n    transform: translateX(-100%);\n    left: 0;\n    top: 0;\n    height: 100vh;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .layout-wrapper .layout-mask {\n    z-index: 998;\n    background-color: var(--mask-bg);\n  }\n  .layout-wrapper .layout-mask.layout-mask-enter-from, .layout-wrapper .layout-mask.layout-mask-leave-to {\n    background-color: transparent;\n  }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-sidebar {\n    transform: translateX(0);\n  }\n  .layout-wrapper.layout-mobile-sidebar-active .layout-mask {\n    display: block;\n  }\n  .body-overflow-hidden {\n    overflow: hidden;\n  }\n}\n.card {\n  background-color: var(--surface-card);\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n  border-radius: 12px;\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08) !important;\n}\n.card.card-w-title {\n  padding-bottom: 2rem;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin: 1.5rem 0 1rem 0;\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.2;\n  color: inherit;\n}\nh1:first-child, h2:first-child, h3:first-child, h4:first-child, h5:first-child, h6:first-child {\n  margin-top: 0;\n}\n\nh1 {\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\nh3 {\n  font-size: 1.75rem;\n}\n\nh4 {\n  font-size: 1.5rem;\n}\n\nh5 {\n  font-size: 1.25rem;\n}\n\nh6 {\n  font-size: 1rem;\n}\n\nmark {\n  background: #FFF8E1;\n  padding: 0.25rem 0.4rem;\n  border-radius: 12px;\n  font-family: monospace;\n}\n\nblockquote {\n  margin: 1rem 0;\n  padding: 0 2rem;\n  border-left: 4px solid #90A4AE;\n}\n\nhr {\n  border-top: solid var(--surface-border);\n  border-width: 1px 0 0 0;\n  margin: 1rem 0;\n}\n\np {\n  margin: 0 0 1rem 0;\n  line-height: 1.5;\n}\np:last-child {\n  margin-bottom: 0;\n}","* {\n    box-sizing: border-box;\n}\n\nhtml {\n    height: 100%;\n    font-size: $fontSize;\n}\n\nbody {\n    font-family: var(--font-family);\n    color: var(--text-color);\n    background-color: #ffffff;\n    margin: 0;\n    padding: 0;\n    min-height: 100%;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\na, button {\n    text-decoration: none;\n    color: var(--primary-color);\n}\n\n.layout-theme-light {\n    background-color: #ffffff;\n}\n",".layout-topbar {\n    position: fixed;\n    height: 5rem;\n    z-index: 997;\n    left: 0;\n    top: 0;\n    width: 100%;\n    padding: 0 2rem;\n    background-color: var(--surface-card);\n    transition: left $transitionDuration;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08);\n\n    .layout-topbar-logo {\n        display: flex;\n        align-items: center;\n        color: var(--surface-900);\n        font-size: 1.5rem;\n        font-weight: 500;\n        width: 300px;\n        border-radius: 12px;\n\n        img {\n            height: 2.5rem;\n            margin-right: .5rem;\n        }\n\n        &:focus {\n            @include focused();\n        }\n    }\n\n    .layout-topbar-button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        color: var(--text-color-secondary);\n        border-radius: 50%;\n        width: 3rem;\n        height: 3rem;\n        cursor: pointer;\n        transition: background-color $transitionDuration;\n\n        &:hover {\n            color: var(--text-color);\n            background-color: var(--surface-hover);\n        }\n\n        &:focus {\n            @include focused();\n        }\n\n        i {\n            font-size: 1.5rem;\n        }\n\n        span {\n            font-size: 1rem;\n            display: none;\n        }\n    }\n\n    .layout-menu-button {\n        margin-left: 2rem;\n    }\n\n    .layout-topbar-menu-button {\n        display: none;\n\n        i {\n            font-size: 1.25rem;\n        }\n    }\n\n    .layout-topbar-menu {\n        margin: 0 0 0 auto;\n        padding: 0;\n        list-style: none;\n        display: flex;\n\n        .layout-topbar-button {\n            margin-left: 1rem;\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .layout-topbar {\n        justify-content: space-between;\n\n        .layout-topbar-logo {\n            width: auto;\n            order: 2;\n        }\n\n        .layout-menu-button {\n            margin-left: 0;\n            order: 1;\n        }\n\n        .layout-topbar-menu-button {\n            display: inline-flex;\n            margin-left: 0;\n            order: 3;\n        }\n\n        .layout-topbar-menu {\n            margin-left: 0;\n            position: absolute;\n            flex-direction: column;\n            background-color: var(--surface-overlay);\n            box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08);\n            border-radius: 12px;\n            padding: 1rem;\n            right: 2rem;\n            top: 5rem;\n            min-width: 15rem;\n            display: none;\n            -webkit-animation: scalein 0.15s linear;\n            animation: scalein 0.15s linear;\n\n            &.layout-topbar-menu-mobile-active {\n                display: block\n            }\n\n            .layout-topbar-button {\n                margin-left: 0;\n                display: flex;\n                width: 100%;\n                height: auto;\n                justify-content: flex-start;\n                border-radius: 12px;\n                padding: 1rem;\n\n                i {\n                    font-size: 1rem;\n                    margin-right: .5rem;\n                }\n\n                span {\n                    font-weight: medium;\n                    display: block;\n                }\n            }\n        }\n    }\n}\n","@mixin focused() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: var(--focus-ring);\n}\n\n@mixin focused-inset() {\n    outline: 0 none;\n    outline-offset: 0;\n    transition: box-shadow .2s;\n    box-shadow: inset var(--focus-ring);\n}\n",".layout-sidebar {\n    position: fixed;\n    width: 300px;\n    height: calc(100vh - 9rem);\n    z-index: 999;\n    overflow-y: auto;\n    user-select: none;\n    top: 7rem;\n    left: 2rem;\n    transition: transform $transitionDuration, left $transitionDuration;\n    background-color: var(--surface-overlay);\n    border-radius: 12px;\n    padding: 1.5rem;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08)\n}\n\n.layout-menu {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n\n    li {\n        &.layout-menuitem-category {\n            margin-top: .75rem;\n\n            &:first-child {\n                margin-top: 0;\n            }\n        }\n\n        .layout-menuitem-root-text {\n            text-transform: uppercase;\n            color:var(--surface-900);\n            font-weight: 600;\n            margin-bottom: .5rem;\n            font-size: .875rem;\n        }\n\n        a {\n            cursor: pointer;\n            text-decoration: none;\n            display: flex;\n            align-items: center;\n            color:var(--text-color);\n            transition: color $transitionDuration;\n            border-radius: $borderRadius;\n            padding: .75rem 1rem;\n            transition: background-color .15s;\n\n            span {\n                margin-left: 0.5rem;\n            }\n\n            .menuitem-toggle-icon {\n                margin-left: auto;\n            }\n\n            &:focus {\n                @include focused-inset();\n            }\n\n            &:hover {\n                background-color: var(--surface-hover);\n            }\n\n            &.router-link-exact-active {\n                font-weight: 700;\n                color: var(--primary-color);\n            }\n\n            .p-badge {\n                margin-left: auto;\n            }\n        }\n\n        &.active-menuitem {\n            > a {\n                .menuitem-toggle-icon {\n                    &:before {\n                        content: '\\e933';\n                    }\n                }\n            }\n        }\n\n        ul {\n            list-style-type: none;\n            margin: 0;\n            padding: 0;\n\n            &.layout-submenu-wrapper-enter {\n                max-height: 0;\n            }\n\n            &.layout-submenu-wrapper-enter-active {\n                overflow: hidden;\n                max-height: 1000px;\n                transition: max-height 1s ease-in-out;\n            }\n\n            &.layout-submenu-wrapper-enter-done {\n                transform: none;\n            }\n\n            &.layout-submenu-wrapper-exit {\n                max-height: 1000px;\n            }\n\n            &.layout-submenu-wrapper-exit-active {\n                overflow: hidden;\n                max-height: 0;\n                transition: max-height 0.45s cubic-bezier(0.86, 0, 0.07, 1);\n            }\n\n            ul {\n                padding-left: 1rem;\n            }\n        }\n    }\n}\n",".layout-config {\n    position: fixed;\n    top: 0;\n    padding: 0;\n    right: 0;\n    width: 20rem;\n    z-index: 999;\n    height: 100vh;\n    transform: translateX(100%);\n    transition: transform $transitionDuration;\n    backface-visibility: hidden;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08) !important;\n    color: var(--text-color);\n    background-color: var(--surface-overlay);\n    border-top-left-radius: 12px;\n    border-bottom-left-radius: 12px;\n\n    &.layout-config-active {\n        transform: translateX(0);\n    }\n\n    .layout-config-button {\n        display: block;\n        position: absolute;\n        width: 52px;\n        height: 52px;\n        line-height: 52px;\n        background-color: var(--primary-color);\n        color: var(--primary-color-text);\n        text-align: center;\n        top: 230px;\n        left: -52px;\n        z-index: -1;\n        overflow: hidden;\n        cursor: pointer;\n        border-top-left-radius: $borderRadius;\n        border-bottom-left-radius: $borderRadius;\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n        transition: background-color $transitionDuration;\n\n        i {\n            font-size: 32px;\n            line-height: inherit;\n            cursor: pointer;\n            transform: rotate(0deg);\n            transition: color $transitionDuration, transform 1s;\n        }\n    }\n\n    .layout-config-close {\n        position: absolute;\n        right: 1rem;\n        top: 1rem;\n        z-index: 1;\n    }\n\n    .layout-config-content {\n        position: relative;\n        overflow: auto;\n        height: 100vh;\n        padding: 2rem;\n    }\n\n    .config-scale {\n        display: flex;\n        align-items: center;\n        margin: 1rem 0 2rem 0;\n\n        .p-button {\n            margin-right: .5rem;\n        }\n\n        i {\n            margin-right: .5rem;\n            font-size: .75rem;\n            color: var(--text-color-secondary);\n\n            &.scale-active {\n                font-size: 1.25rem;\n                color: var(--primary-color);\n            }\n        }\n    }\n\n    .free-themes {\n        img {\n            width: 2rem;\n            border-radius: 4px;\n            transition: transform .2s;\n            display: block;\n\n            &:hover {\n                transform: scale(1.1);\n            }\n        }\n\n        span {\n            font-size: .75rem;\n            margin-top: .25rem;\n        }\n    }\n}\n",".layout-main-container {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    justify-content: space-between;\n    padding: 2rem 2rem 2rem 4rem;\n    transition: margin-left $transitionDuration;\n}\n\n.layout-main {\n    flex: 1 1 auto;\n}",".layout-footer {\n    transition: margin-left $transitionDuration;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 1rem;\n    border-top: 1px solid var(--surface-border);\n}\n","@media (min-width: 992px) {\n    .layout-wrapper {\n        &.layout-overlay {\n            .layout-main-container {\n                margin-left: 0;\n                padding-left: 2rem;\n            }\n\n            .layout-sidebar {\n                transform: translateX(-100%);\n                left: 0;\n                top: 0;\n                height: 100vh;\n                border-top-left-radius: 0;\n                border-bottom-left-radius: 0;\n            }\n\n            &.layout-overlay-sidebar-active {\n                .layout-sidebar {\n                    transform: translateX(0);\n                }\n            }\n        }\n\n        &.layout-static {\n            .layout-main-container {\n                margin-left: 300px;\n            }\n\n            &.layout-static-sidebar-inactive {\n                .layout-sidebar {\n                    transform: translateX(-100%);\n                    left: 0;\n                }\n\n                .layout-main-container {\n                    margin-left: 0;\n                    padding-left: 2rem;\n                }\n            }\n        }\n\n        .layout-mask {\n            display: none;\n        }\n    }\n}\n\n@media (max-width: 991px) {\n    .layout-wrapper {\n        .layout-main-container {\n            margin-left: 0;\n            padding-left: 2rem;\n        }\n\n        .layout-sidebar {\n            transform: translateX(-100%);\n            left: 0;\n            top: 0;\n            height: 100vh;\n            border-top-left-radius: 0;\n            border-bottom-left-radius: 0;\n        }\n\n        .layout-mask {\n            z-index: 998;\n            background-color: var(--mask-bg);\n\n            &.layout-mask-enter-from,\n            &.layout-mask-leave-to {\n                background-color: transparent;\n            }\n        }\n\n        &.layout-mobile-sidebar-active {\n            .layout-sidebar {\n                transform: translateX(0);\n            }\n\n            .layout-mask {\n                display: block;\n            }\n        }\n    }\n\n    .body-overflow-hidden {\n        overflow: hidden;\n    }\n}\n",".card {\n    background-color: var(--surface-card);\n    padding: 1.5rem;\n    margin-bottom: 1rem;\n    border-radius: $borderRadius;\n    box-shadow: 0px 3px 5px rgba(0,0,0,.02), 0px 0px 2px rgba(0,0,0,.05), 0px 1px 4px rgba(0,0,0,.08) !important;\n\n    &.card-w-title {\n        padding-bottom: 2rem;\n    }\n}\n","h1, h2, h3, h4, h5, h6 {\n    margin: 1.5rem 0 1rem 0;\n    font-family: inherit;\n    font-weight: 500;\n    line-height: 1.2;\n    color: inherit;\n\n    &:first-child {\n        margin-top: 0;\n    }\n}\n\nh1 {\n    font-size: 2.5rem;\n}\n\nh2 {\n    font-size: 2rem;\n}\n\nh3 {\n    font-size: 1.75rem;\n}\n\nh4 {\n    font-size: 1.5rem;\n}\n\nh5 {\n    font-size: 1.25rem;\n}\n\nh6 {\n    font-size: 1rem;\n}\n\nmark {\n    background: #FFF8E1;\n    padding: .25rem .4rem;\n    border-radius: $borderRadius;\n    font-family: monospace;\n}\n\nblockquote {\n    margin: 1rem 0;\n    padding: 0 2rem;\n    border-left: 4px solid #90A4AE;\n}\n\nhr {\n    border-top: solid var(--surface-border);\n    border-width: 1px 0 0 0;\n    margin: 1rem 0;\n}\n\np {\n    margin: 0 0 1rem 0;\n    line-height: 1.5;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
